import * as Yup from "yup";
import React from "react";
import { FilePreview, FormItemProps } from "@/components/Form/types";

import ImageComponent from "@/components/UiElements/ImageComponent";



const Items: Array<FormItemProps> = [

    {
        name: 'name',
        label: 'Name',
        placeholder: 'Enter category name',
        type: 'Text',
        help: 'Enter the customer-facing category name. Keep it short and easy to recognize, such as Animals, Monograms, or Wedding.',
        defaultValue: null,
        validation: Yup.string().required('Name is required'),
        classNames: {container: 'col-span-6 '},
        autoFocus: true,
    },
    {
        name: 'description',
        label: 'Description',
        placeholder: 'Enter description',
        type: 'LongText',
        help: 'Describe the type of graphics stored in this category so admins and customers can understand when to use it.',
        defaultValue: null,
        classNames: {container: 'col-span-12 break-line'},
        itemOptions: {
            rows: 3
        },
        validation: Yup.string().required('Description is required'),
    },

    {
        name: 'img',
        label: 'Category thumbnail',
        type: 'File',
        help: 'Upload the representative image used to identify this category. Choose a clear image that still reads well at thumbnail size.',
        classNames: {
            container: 'col-span-12 break-line',
            content: '!h-[83px]'
        },
        placeholder: "Drag and drop your image here",
        itemOptions: {
            filePreview: (file: FilePreview) => (
                file.string ? <ImageComponent
                    src={file.string}
                    style={{ height: "70px", width: "70px" }}
                    className="w-[70px] h-[70px]"
                /> : null
            ),
            acceptFormat: 'image/*, .avif, .webp, .svg, .png, .jpg, .jpeg',
        },
        validation:Yup.object().typeError('Thumbnail is required')
    },
    {
        name: 'isActive',
        label: 'Active',
        placeholder: 'Enter profile name',
        type: 'Checkbox',
        help: 'Turn this on when the category is ready to use. Turn it off to keep the category saved while removing it from the normal active experience.',
        defaultValue: false,
        classNames: {
            container: 'col-span-6 !justify-center',
        },
    },
    {
        name: 'showOnHome',
        label: 'Show on Home',
        placeholder: 'Enter profile name',
        type: 'Checkbox',
        help: 'Feature this category on the customer-facing home or starting view. Categories shown there should normally also be Active.',
        defaultValue: false,
        classNames: {
            container: 'col-span-6 !justify-center',
        }
    },
    {
        name: 'isGeneric',
        label: 'Generic Category',
        type: 'Checkbox',
        help: 'Use this for a general artwork category. Generic categories are not available in the Specific Graphic Category field of a product section; leave this off when the category must be assigned there.',
        defaultValue: false,
        classNames: {
            container: 'col-span-12 !justify-center',
        },
    },
]

export default Items;
